<script>
export default {
  name: 'modal',
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>
<template>
  <transition name="modal-fade">
    <div class="modal-backdropNP">
      <div class="modalNP"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
      >
        <header
          class="modal-headerNP"
          id="modalTitle"
        >
          <slot name="header">
           <div class="page-titleNP" id="ph-title"><h2>Notificación de privacidad</h2></div>

            <button
              class="btn-closeNP"
              @click="close"
              aria-label="Close modal"
            >
              x
            </button>
          </slot>
        </header>
        <section
          class="modal-bodyNP"
          id="modalDescription"
        >
          <slot name="body">
            <div class="page-bodyNP">
              <p class="texto-interiorNP">Datos protegidos por la Ley de Protección de Datos Perú.</p>
              <p class="texto-interiorNP">La información proporcionada no será&nbsp;vendida a terceros ni utilizada&nbsp;con fines distintos a los de compra en Pidealtoque.pe o sus afiliados</p>
            </div>
          </slot>
        </section>
        <!--<footer class="modal-footer">
          <slot name="footer">
            I'm the default footer!

            <button
              type="button"
              class="btn-green"
              @click="close"
              aria-label="Close modal"
            >
              Close me!
            </button>
          </slot>
        </footer>-->
      </div>
    </div>
  </transition>
</template>
<style scoped>
@import '../assets/modalnotificacionstyle.css';
</style>
